import { getBanners } from 'service/campaigns'
import * as providers from './provider'

export default ({ setList, setError, initialState, latestRequestId }) => {
  const fetchBanner = async campaigns => {
    const { listBanners } = getBanners({ campaigns })

    return setList(prev => ({
      ...prev,
      banners: listBanners,
      isLoadingBanners: false,
    }))
  }
  const setField = (value, field) =>
    setList(prev => ({ ...prev, [field]: value }))

  const setListLoading = value =>
    setList(prev => ({ ...prev, loadingList: value }))

  const fetchList = async query => {
    const requestId = latestRequestId.current + 1
    latestRequestId.current = requestId

    setField(true, 'loadingList')

    const isStale = () => latestRequestId.current !== requestId

    const listData = await providers.getEstatesList(query)

    if (isStale()) return undefined

    if (listData && listData.error) {
      return setError(listData.code)
    }

    const { list = [], pagination = {} } = listData || {}

    return setList(prev => ({
      ...prev,
      estatesList: list,
      pagination,
      loadingList: false,
    }))
  }

  const clearList = () => {
    latestRequestId.current += 1
    setList(() => ({ ...initialState }))
  }

  return {
    fetchBanner,
    setField,
    fetchList,
    setListLoading,
    clearList,
  }
}
